import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 0L6 6L6 12L-5.24537e-07 6L6 0Z",
    fill: "#171717"
  })
], -1)

import { useTooltip } from '@/stores/tooltip';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheTooltipBase',
  setup(__props) {

const tooltip = useTooltip()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(tooltip).tooltip)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["v-tooltip", _unref(tooltip).tooltip.placement]),
              style: _normalizeStyle({ left: _unref(tooltip).tooltip.x+'px', top: _unref(tooltip).tooltip.y+'px' })
            }, [
              _createTextVNode(_toDisplayString(_unref(tooltip).tooltip.text) + " ", 1),
              _hoisted_1
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})